export default {
  contractFull: "contracts/{id}/?full=1",
  contractSearch: "contracts/",
  diaries: "contracts/{id}/logs",
  user: "users/{id}",
}
